import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from './services/login/auth.service';
import { BodyComponent } from './layout/body/body.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, BodyComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  currentYear = new Date().getFullYear();
  showLayout = true;
  title = 'observatory';
  opened = true;

  constructor(private router: Router, private authService: AuthService) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const url = (event as NavigationEnd).url;
        this.showLayout = !url.includes('login');
      });
  }
}
